import { useSyncExternalStore } from 'react';
import {
  getGrowthBookConfigLoader,
  type GrowthBookSchema,
} from '@doxyme/config';

export const useGrowthBookFlag = <T extends keyof GrowthBookSchema>(key: T) =>
  useSyncExternalStore(
    getGrowthBookConfigLoader().subscribe.bind(getGrowthBookConfigLoader()),
    () => getGrowthBookConfigLoader().getOptional(key),
  );
